import { LaboratoryDTO } from "./LaboratoryDTO";

export class ExtractionReportOptionDTO {

    id?: number;
    reportName: string;
} 